import projectDetailsShowComponent from './project-details-show.component';

const projectDetailsShowModule = angular.module('projectDetailsShow', [
])
  .component('projectDetailsShow', projectDetailsShowComponent)
  .name;

export default projectDetailsShowModule;
